<script setup lang="ts">
defineProps({
  viewingTenant: { type: Boolean, default: false },
});
</script>

<template>
  <div class="hamburger-container" :class="{ banner: viewingTenant }">
    <span class="material-icons text-primary cursor-pointer">menu</span>
  </div>
</template>

<style scoped lang="scss">
.hamburger-container {
  display: none;

  @media (max-width: 480px) {
    display: flex;
    position: fixed;
    top: 12px;
    left: 8px;
    z-index: 10;
  }
  &.banner {
    top: 44px;
  }
}
</style>
